import type { ReactNode } from 'react'

type ProjectMenuItemProps = {
  icon: ReactNode
  label: string
  onClick: () => void
  danger?: boolean
}

export function ProjectMenuItem({ icon, label, onClick, danger = false }: ProjectMenuItemProps) {
  return (
    <button className={`project-menu-item${danger ? ' danger' : ''}`} type="button" onClick={onClick}>
      {icon}
      {label}
    </button>
  )
}
